// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.contract-section[data-v-16632664] {\n  display: block;\n  width: 100%;\n  margin-top: 20px;\n  font-size: 12px;\n}\n.contract-section__link[data-v-16632664] {\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
